(function(){
	'use strict';

	angular
		.module('app')
		.controller('MainController', MainController);
		//MainController.$inject = ['$scope','$analytics'];
		function MainController($rootScope, $scope, $analytics, $location, $state, API){
			let vm = this;

			vm.showSubProducts = false;
			vm.showSubContact = false;

			vm.listSubCategories = {}
			vm.enderecos = [];
			vm.redesSociais = {};

			vm.menuColored = $state.current.name != 'home';

			vm.openMenu = () => vm.isMenuMobileOpen = true;
			vm.closeMenu = () => vm.isMenuMobileOpen = false;

			vm.mobileLinkClick = () => {
				vm.closeMenu();
				vm.scrollTop();
			}

			$scope.$on('$routeChangeStart', function (next, current) {
				$analytics.pageTrack($location.url());
			});

			vm.$onInit = () => {
	      _loadFromApi();
	    }

	    function _loadFromApi() {
	      _loadCategoriesProducts();
			  _loadEnderecos();
			  _loadRedesSociais();
				_loadBrax();
	    }

			function _loadEnderecos() {
			  API.get('endereco')
					.then(result => result.data)
					.then(enderecos => vm.enderecos = enderecos)
					.catch(error => {
					  console.log(error, 'error');
					});
			}

			function _loadBrax() {
				API.get('produto_brastelha/categoria/bras-x')
					.then(result => result.data)
					.then(category => vm.categoryBrax = category)
					.catch(error => {
					  console.log(error, 'error');
					});
			}

			function _loadRedesSociais() {
				API.get(`configuracao/sociais`)
				.then(result => vm.redesSociais = result.data[0])
				.catch(error => {
				  console.log(error, 'error');
				});
			}

			function _loadNews() {
		      API.get('post')
		        .then(result => result.data)
		        .then(news => vm.news = news)
		        .catch((err) => {
		          vm.news = [{error: true}];
		        });
		    }

	    function _loadCategoriesProducts() {
	      API.get(`produto_brastelha/categoria`)
	        .then(result => result.data)
					.then(categories => vm.listSubCategories = categories.filter(category => category.id_categoria != 184))
	        .catch(error => {
	          console.log(error, 'error');
	          //$state.go('news');
	        });
	    }

			vm.submitNews = (news) => {
				API.post(`news`, news)
			   .then(result => swal('Enviado com sucesso!', '', 'success'))
			   .then(() => {
	  				angular.copy({}, news)
	  				vm.ItsOkayForm.$submitted = false;
	  				vm.ItsOkayForm.$setPristine();
			   })
			   .catch(error => {
	    			console.log(error, 'error');
	    			swal({title: 'Opss...!', text: 'Tente novamente!', type: 'error'}).then(() => $state.reload());
			   });
			}

			vm.scrollTop = () => $('body, html').animate({scrollTop: 0}, 300);

			vm.changeLanguage = lang => {
				var event = document.createEvent('Event');
				vm.languageMenu = false;
				event.initEvent('change', true, true);
				document.querySelector('.goog-te-combo').value = lang;
				document.querySelector('.goog-te-combo').dispatchEvent(event);
				if(lang == 'pt'){
					location.reload();
				}
			}

			$rootScope.$on('$stateChangeSuccess', (next, current) => {
				_resetMenu(current);
			})

			function _resetMenu(current) {
				vm.menuColored = current.name != 'home';
				vm.scrollTop();
				vm.closeMenu();
				vm.showSubProducts = false;
				vm.showSubContact = false;
			}

		}

})();
